import React from 'react';
import { PhoneIcon, ArrowRightIcon } from 'lucide-react';
export function StickyMobileCTA() {
  return <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 p-4 z-50 shadow-[0_-4px_20px_rgba(0,0,0,0.05)] flex gap-3" data-id="element-276">
      <a href="tel:+18556052101" className="w-[60px] h-[60px] bg-slate-100 text-[#0F172A] rounded-full flex items-center justify-center shrink-0" aria-label="Call us" data-id="element-277">
        <PhoneIcon className="w-6 h-6" data-id="element-278" />
      </a>
      <button onClick={() => {
      const form = document.getElementById('hero-form');
      form?.scrollIntoView({
        behavior: 'smooth'
      });
    }} className="flex-1 bg-[#D4A24C] hover:bg-[#B8862F] text-white font-bold py-4 px-4 rounded-full flex items-center justify-center text-base transition-colors shadow-lg" data-id="element-279">
        Get Cash Offer
      </button>
    </div>;
}